module.exports = __webpack_public_path__ + "media/images/brand/main_nav/cow_grill_250-4764b21489637a944f37090b3b5c4737.png";